import { Group, Loader } from '@mantine/core';
import { IconFileFilled } from '@tabler/icons-react';
import classnames from 'classnames';
import { useEffect } from 'react';

import { DirectoryIcon } from 'src/Components/Modals/DirectorySelectionModal/DirectoryLeaf/DirectoryIcon';
import { useTranslateFolderName } from 'src/Hooks/Format/useTranslateFolderName';
import useFetchDocuments from 'src/Hooks/Queries/useFetchDocuments';
import { AssetStorageItemDtoTypeEnum } from 'src/Services/API/generated';

import styles from './DirectoryLeaf.module.scss';
import { Props } from './DirectoryLeaf.types';

const DirectoryLeaf = ({ node, expanded, elementProps, onChildrenLoaded }: Props) => {
  const translateFolderName = useTranslateFolderName();

  const isFolder = node.isFolder;

  const shouldFetch = isFolder && expanded && (!node.children || node.children.length === 0);

  const { data: childrenData, isLoading } = useFetchDocuments(node.value, { enabled: shouldFetch });

  useEffect(() => {
    if (childrenData && childrenData.length > 0 && shouldFetch) {
      const treeData = childrenData.map(data => ({
        label: data.name,
        value: `${data.path}${data.name}`,
        isFolder: data.type === AssetStorageItemDtoTypeEnum.Folder,
        id: data.id,
      }));
      onChildrenLoaded(node.value, treeData);
    }
  }, [childrenData, node.value, shouldFetch, onChildrenLoaded]);

  return (
    <>
      <Group
        gap={5}
        {...elementProps}
        className={classnames(elementProps.className, styles.group)}
        wrap={'nowrap'}
      >
        {isFolder ? (
          <>
            <DirectoryIcon expanded={expanded} />
            {isLoading && <Loader size="xs" style={{ marginLeft: 5 }} />}
          </>
        ) : (
          <IconFileFilled className={styles.fileIcon} color="#0E5B61" size={14} stroke={2.5} />
        )}
        <span className={styles.label}>{translateFolderName(node.label?.toString() ?? '')}</span>
      </Group>
    </>
  );
};

export default DirectoryLeaf;
